import getSelectedText from '../../utils/getSelectedText';
export default function isActiveInline(editor, inlineType) {
  var inlines = editor.value.inlines;

  if (inlines.size !== 1 || inlines.first().type !== inlineType) {
    return false;
  }

  var inline = editor.value.document.getNode(inlines.first().key);
  var inlineText = inline.getLastText().text;
  var selectionText = getSelectedText(editor);
  return inlineText === selectionText;
}